/**
 * MilaVela — real lunar-phase calculation (a synodic-month calculation, not
 * a lookup table). Runs once on load: writes today's cycle day + phase name
 * into every [data-js-phase-day]/[data-js-phase-name] element, and marks the
 * matching disc .is-today inside every [data-mv-ephemeris-strip] on the
 * page. This is the one signature device reused across the hero masthead,
 * the ephemeris table, and (later) product pages — it must stay computed,
 * never hardcoded.
 */
(function () {
  var SYNODIC_MONTH = 29.530588853; // days
  var KNOWN_NEW_MOON_UTC = Date.UTC(2000, 0, 6, 18, 14); // 2000-01-06 18:14 UTC

  var PHASE_NAMES = [
    'New Moon',
    'Waxing Crescent',
    'First Quarter',
    'Waxing Gibbous',
    'Full Moon',
    'Waning Gibbous',
    'Last Quarter',
    'Waning Crescent',
  ];

  function computePhase(date) {
    var days = (date.getTime() - KNOWN_NEW_MOON_UTC) / 86400000;
    var cyclePos = days % SYNODIC_MONTH;
    if (cyclePos < 0) cyclePos += SYNODIC_MONTH;
    var cycleDay = Math.floor(cyclePos) + 1; // 1-indexed
    var phaseIndex = Math.floor((cyclePos / SYNODIC_MONTH) * 8) % 8;
    return { cycleDay: cycleDay, phaseIndex: phaseIndex, phaseName: PHASE_NAMES[phaseIndex] };
  }

  function applyPhase() {
    var phase = computePhase(new Date());

    var dayEls = document.querySelectorAll('[data-js-phase-day]');
    for (var i = 0; i < dayEls.length; i++) dayEls[i].textContent = phase.cycleDay;

    var nameEls = document.querySelectorAll('[data-js-phase-name]');
    for (var j = 0; j < nameEls.length; j++) nameEls[j].textContent = phase.phaseName.toUpperCase();

    var strips = document.querySelectorAll('[data-mv-ephemeris-strip]');
    for (var s = 0; s < strips.length; s++) {
      var discs = strips[s].querySelectorAll('[data-phase-index]');
      for (var d = 0; d < discs.length; d++) {
        var isToday = Number(discs[d].getAttribute('data-phase-index')) === phase.phaseIndex;
        discs[d].classList.toggle('is-today', isToday);
      }
    }

    window.MilaVelaPhase = phase; // exposed for any future product-page use
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPhase);
  } else {
    applyPhase();
  }
})();
